/** A task's classification: reading it, choosing and confirming codes, asking for suggestions, and searching the scheme. */

import { get, post, put } from "@/services/api-client";
import type {
  ClassificationChoice,
  ClassificationResponse,
  CpcSearchResponse,
} from "@patent-studio/api-types";

/** The most results a search of the scheme shows. */
export const CPC_SEARCH_LIMIT = 12;

export function readClassification(
  taskId: string,
): Promise<ClassificationResponse> {
  return get<ClassificationResponse>(`/tasks/${taskId}/classification`);
}

/** Store the attorney's codes under the version read; confirmed or not. */
export function chooseClassification(
  taskId: string,
  choice: ClassificationChoice,
): Promise<ClassificationResponse> {
  return put(`/tasks/${taskId}/classification`, choice);
}

/** Ask the worker for codes from the disclosure the task holds now. */
export function requestClassificationRun(taskId: string): Promise<unknown> {
  return post(`/tasks/${taskId}/classification/run`);
}

export function searchCpc(query: string): Promise<CpcSearchResponse> {
  const params = new URLSearchParams({
    q: query,
    limit: String(CPC_SEARCH_LIMIT),
  });
  return get<CpcSearchResponse>(`/cpc/search?${params.toString()}`);
}
